import Configuration from './Configuration';

export default function getApiHostName(): string {
  return `${Configuration.Current().apiHostName}/omni/elasticstack/api/v1/documents`;
}
